import React from "react";
import withStyles from "react-jss";
import Textarea from "react-textarea-autosize";

const styles = (theme) => {
	return {
		replyForm: {
			width: "780px",
			marginLeft: "auto",
		},
		replyFormHeader: {
			fontFamily: theme.fonts.bold,
			fontSize: "16px",
			lineHeight: "1",
			letterSpacing: "2.3px",
			color: theme.palette.colors.darkSlateBlue,
			marginBottom: "17px",
			textTransform: "uppercase",
		},
		replyFormContent: {
			display: "flex",
			alignItems: "flex-start",
		},
		replyFormTAWrapper: {
			width: "580px",
			marginRight: "20px",
			position: "relative",
			border: `1px solid ${theme.palette.colors.disabled}`,
			borderRadius: "10px 0 10px 10px",
			backgroundColor: theme.palette.colors.white,
			"& textarea": {
				width: "100%",
				height: "100%",
				resize: "none",
				borderRadius: "10px 0 10px 10px",
				padding: "20px",
				border: "none",
				overflow: "hidden",
				minHeight: "140px",
			},
			"&:before": {
				content: '""',
				position: "absolute",
				right: "-23px",
				top: 0,
				width: 0,
				height: 0,
				borderBottom: `24px solid ${theme.palette.colors.transparent}`,
				borderLeft: `24px solid ${theme.palette.colors.white}`,
				zIndex: "4",
			},
			"&:after": {
				content: '""',
				position: "absolute",
				right: "-25px",
				top: "-1px",
				width: 0,
				height: 0,
				borderBottom: `25px solid ${theme.palette.colors.transparent}`,
				borderLeft: `25px solid ${theme.palette.colors.disabled}`,
				zIndex: "3",
			},
		},
		replyFormButtonWrapper: {
			margin: "0 auto",
		},
		replyFormButton: {
			width: "80px",
			height: "80px",
			borderRadius: "50%",
			backgroundColor: theme.palette.colors.purplishBlue,
			border: "none",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			cursor: "pointer",
			"& span": {
				color: theme.palette.colors.yellow,
				fontSize: "24px",
			},
			"&:disabled": {
				backgroundColor: theme.palette.colors.disabled,
				"& span": {
					color: theme.palette.colors.white,
				},
			},
		},
		error: {
			margin: "10px 0",
			padding: "0",
			fontSize: "16px",
			color: theme.palette.colors.coralPink,
		},
		[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
			replyFormTAWrapper: {
				width: "620px",
			},
		},
		[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
			replyForm: {
				width: "100%",
			},
			replyFormContent: {
				flexWrap: "wrap",
			},
			replyFormTAWrapper: {
				width: "100%",
				marginRight: 0,
				marginBottom: "40px",
				borderRadius: "10px 10px 0 10px",
				"& textarea": {
					borderRadius: "10px 10px 0 10px",
				},
				"&:before": {
					right: 0,
					top: "inherit",
					bottom: "-23px",
					borderLeft: "0",
					borderRight: `24px solid ${theme.palette.colors.white}`,
				},
				"&:after": {
					right: "-1px",
					top: "inherit",
					bottom: "-25px",
					borderLeft: "0",
					borderRight: `25px solid ${theme.palette.colors.disabled}`,
				},
			},
			replyFormButtonWrapper: {
				width: "100%",
			},
			replyFormButton: {
				width: "70px",
				height: "70px",
				marginLeft: "auto",
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			replyForm: {
				width: "100%",
			},
			replyFormContent: {
				position: "relative",
			},
			replyFormTAWrapper: {
				width: "100%",
				marginRight: 0,
				borderRadius: "10px",
				"& textarea": {
					borderRadius: "10px",
					padding: "10px",
					paddingRight: "60px",
					minHeight: "60px",
				},
				"&:before": {
					display: "none",
				},
				"&:after": {
					display: "none",
				},
			},
			replyFormButtonWrapper: {
				margin: "0 auto",
				position: "absolute",
				right: "25px",
				top: "50%",
				transform: "translateY(-50%)",
			},
			replyFormButton: {
				width: "auto",
				height: "auto",
				borderRadius: 0,
				backgroundColor: theme.palette.colors.transparent,
				"& span": {
					color: theme.palette.colors.purplishBlue,
				},
				"&:disabled": {
					backgroundColor: theme.palette.colors.transparent,
					"& span": {
						color: theme.palette.colors.disabled,
					},
				},
			},
		},
	};
};

class ReviewReplyForm extends React.Component {
	render() {
		let classes = this.props.classes;
		let text = this.props.text;
		let actionForButton = this.props.userIsAuth
			? this.props.sendComment
			: this.props.openRegistrationHandler;
		return (
			<div className={classes.replyForm}>
				<div className={classes.replyFormHeader}>{text.YOUR_COMMENT}</div>
				<div className={classes.replyFormContent}>
					<div datatest="review_comment_input" className={classes.replyFormTAWrapper}>
						<Textarea
							value={this.props.comment}
							onChange={(e) => this.props.changeComment(e)}
							useCacheForDOMMeasurements
						/>
					</div>
					<div className={classes.replyFormButtonWrapper}>
						<button
							datatest="review_comment_send"
							onClick={actionForButton}
							disabled={!this.props.comment}
							className={classes.replyFormButton}
						>
							<span className="icon24 icon-paper-plane" />
						</button>
					</div>
				</div>
				{this.props.error && <div className={classes.error}>{this.props.error}</div>}
			</div>
		);
	}
}

export default withStyles(styles)(ReviewReplyForm);
